<template>
    <div class="overview clearfix">
        <div class="right-col">
          <mam-sub-right-bar
            @send-indexdata="sendIndexDataHandle"
          ></mam-sub-right-bar>
        </div>
        <div class="left-col">
            <data-statistics-mam-sub
                    :data-statistics="accountInfo"
            ></data-statistics-mam-sub>

            <earnings-line-echart></earnings-line-echart>
            <order-list class="order-list-el"></order-list>
        </div>
    </div>
</template>

<script>
  import orderList from '@/components/user/details/common/order/orderList'
  import mamSubRightBar from "@/components/user/details/mamSub/overview/mamSubRightBar";
    import earningsLineEchart from '@/components/user/details/mamSub/overview/earnings/earningsLineEchart'

    import dataStatisticsMamSub from '@/components/user/details/mamSub/overview/dataStatistics/dataStatisticsMamSub'
  export default {
    name: 'index',
    components:{
      mamSubRightBar,
      dataStatisticsMamSub,

      earningsLineEchart,
      orderList,
    },
    data() {
      return {
        accountInfo: {
          balance: 0,
          closeOrder: 3,
          createTime: "",
          credit: 0,
          earningRate: 0,
          enableReadOnly: 0,
          equity: 0,
          leverage: 0,
          login: 0,
          marginFree: 0,
          maxRetracement: 0,
          openOrder: 0,
          profitRate: 0,
          statProfit: 0,
          subLoginNumber: 1,
          times: 1,
        }
      };
    },
    methods: {
      sendIndexDataHandle(accountInfo) {
        this.accountInfo = accountInfo;
      }
    }
  };
</script>
<style lang="scss">
.order-list-el {
  margin-top: 10px;
}
</style>
